<div class="m-[52px] mt-[93px] pb-[63px]">
  <!-- <div class="flex justify-start items-center">
      <img class="mr-[43px]" src="assets/icons/back-arrow.svg" alt="Back icon" />
      <h3 class="title">Expression Of Interest</h3>
    </div> -->
  <!-- <div class="w-[100%] flex justify-end mb-[6px] mt-[106px] mr-[8px]"></div> -->

  <div class="container mt-[40px]">
    <div class="flex justify-between items-center mx-[40px] mt-[40px]">
      <div class="flex flex-col items-end">
        <h3 class="title">Expression Of Interest</h3>
      </div>
      <div class="flex items-center gap-[10px]">
        <!-- Updated container -->
        <!-- <button class="print-button">Print</button> -->
        <img
          src="assets/images/logo.png"
          alt="logo"
          class="h-[78px] w-[78px] rounded-[7px]"
        />
      </div>
    </div>
    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[30px] bg-[#F1F3F5]"
    >
      <p class="!m-0">Selected Companies</p>
    </div>

    <div
      class="!mb-[60px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 !mt-[50px]"
    >
      <div class="!w-[100%] flex items-center">
        <table
          class="!w-[100%] bg-[#fcfcfd] table-auto"
          style="margin-right: 0px"
        >
          <thead
            class="h-[80px] bg-[#DEE2E6] text-[#000000] !text-center justify-center !p-[20px]"
          >
            <tr>
              <th class="px-4 py-2 text-center">Company</th>
              <th class="px-4 py-2 text-center">Name</th>
              <th class="px-4 py-2 text-center">Email</th>
              <th class="px-4 py-2 text-center">Position</th>
              <th class="px-4 py-2 text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngFor="
                let orgDetail of submittedInitiation?.selected_organizations;
                let i = index
              "
            >
              <tr
                class="hover:bg-gray-200 border-b-0 items-center justify-center"
                [ngClass]="{
                  'bg-white': i % 2 === 0,
                  'bg-[#DEE2E6]': i % 2 !== 0
                }"
              >
                <td class="border-b-0 px-4 py-2 text-center">
                  {{
                    orgDetail?.receiving_org_id
                      ? orgDetail?.applicant_organization?.name
                      : orgDetail?.external_company_name
                  }}
                </td>
                <td class="border-b-0 px-4 py-2 text-center">
                  {{ orgDetail?.name }}
                </td>
                <td class="border-b-0 px-4 py-2 text-center">
                  {{ orgDetail?.email }}
                </td>
                <td class="border-b-0 px-4 py-2 text-center">
                  {{ orgDetail?.position }}
                </td>
                <td class="border-b-0 px-4 py-2 text-center">
                  {{ submittedInitiation?.status }}
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[30px] bg-[#F1F3F5]"
    >
      <p class="!m-0">Project Brief</p>
    </div>

    <app-brief-section></app-brief-section>

    <div class="mx-[43px] mt-[51px]">
      <!-- applicant detail -->

      <div class="flex justify-start items-center !mt-5">
        <h4 class="applicant-detail">Applicant Details</h4>
      </div>
      <div class="grid grid-cols-3 gap-y-6 gap-x-[25rem] mt-[40px]">
        <div class="flex flex-col">
          <p class="header-attribute">Company Name</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.company_name }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Contact Person</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.contact_person }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Company Registration Number</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.company_reg_no }}
          </p>
        </div>

        <div class="flex flex-col">
          <p class="header-attribute">Position</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.contact_person_position }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">VAT Registration Number</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.company_vat_no }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Email</p>
          <p class="header-attribute-value">{{ applicantViewData?.email }}</p>
        </div>

        <div class="flex flex-col">
          <p class="header-attribute">Website</p>
          <p class="header-attribute-value">{{ applicantViewData?.website }}</p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Telephone</p>
          <p class="header-attribute-value">{{ applicantViewData?.phone }}</p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Address</p>
          <p class="header-attribute-value">{{ applicantViewData?.address }}</p>
        </div>

        <div class="flex flex-col">
          <p class="header-attribute">City</p>
          <p class="header-attribute-value">{{ applicantViewData?.city }}</p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Country</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.country_id }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">State/Province</p>
          <p class="header-attribute-value">{{ applicantViewData?.state }}</p>
        </div>

        <div class="flex flex-col">
          <p class="header-attribute">Zip Code</p>
          <p class="header-attribute-value">{{ applicantViewData?.zip }}</p>
        </div>
        <!-- Empty cells -->
        <div></div>
        <div></div>
      </div>

      <!-- scope of interest -->

      <div class="flex justify-start items-center mt-[36px]">
        <h4 class="applicant-detail">Scope of Interest</h4>
      </div>
      <div class="grid grid-cols-3 gap-y-6 gap-x-[25rem] mt-[40px]">
        <div class="flex flex-col">
          <p class="header-attribute">Nature of service Required</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.nature_of_service }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Type of Project</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.type_of_project }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Project location</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.project_location }}
          </p>
        </div>

        <div class="flex flex-col">
          <p class="header-attribute">Estimation Project value</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.estimation_price }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Expected Start Date</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.expected_start_date | date : "yyyy-MM-dd" }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Expected End Date</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.expected_end_date | date : "yyyy-MM-dd" }}
          </p>
        </div>

        <!-- Empty cells -->
        <div></div>
        <div></div>
      </div>

      <!-- Experience & Capability (If Applicable) -->

      <div class="flex justify-start items-center mt-[36px]">
        <h4 class="applicant-detail">
          Experience & Capability(If Applicable) 
        </h4>
      </div>
      <div class="grid grid-cols-3 gap-y-6 gap-x-[25rem] mt-[40px]">
        <div class="flex flex-col">
          <p class="header-attribute">Relevant Experience</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.experience }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Key Qualifications</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.qualifications }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Team Composition</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.team_composition }}
          </p>
        </div>

        <!-- Empty cells -->
        <div></div>
        <div></div>
      </div>

      <!--  Compliance & Policies -->

      <div class="flex justify-start items-center mt-[36px]">
        <h4 class="applicant-detail">Compliance & Policies</h4>
      </div>
      <div class="grid grid-cols-3 gap-y-6 gap-x-[25rem] mt-[40px]">
        <div class="flex flex-col">
          <p class="header-attribute">Health, Safety & Environmental Policy</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.health_safety_environmental_policy }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Quality Assurance Certification</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.quality_assurance_cert_attach }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Conflict of Interest Disclosure</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.conflict_of_interest }}
          </p>
        </div>

        <!-- Empty cells -->
        <div></div>
        <div></div>
      </div>

      <!--  Additional Information -->

      <div
        *ngIf="applicantViewData?.additional_information"
        class="flex justify-start items-center mt-[36px]"
      >
        <h4 class="applicant-detail">Additional Information</h4>
      </div>
      <p class="header-attribute-value" style="margin-top: 20px !important">
        {{ applicantViewData?.additional_information }}
      </p>

      <!--   Declaration -->

      <div class="flex justify-start items-center mt-[36px]">
        <h4 class="applicant-detail">Declaration</h4>
      </div>
      <div class="grid grid-cols-3 gap-y-6 gap-x-[25rem] mt-[40px] mb-[40px]">
        <div class="flex flex-col">
          <p class="header-attribute">Name of Authorized Representative</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.authorized_representative }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Position</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.authorized_representative_position }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Signature</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.signature }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Date</p>
          <p class="header-attribute-value">
            {{ applicantViewData?.date | date : "yyyy-MM-dd" }}
          </p>
        </div>

        <!-- Empty cells -->
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</div>

<!-- Dialog content -->
<ng-template #dialogTemplate class="w-[100%]">
  <h2 mat-dialog-title>Print Preview</h2>
  <mat-dialog-content>
    <div>eofjseofielfin</div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeDialog()" class="mr-[30px]">Close</button>
    <button (click)="print()" class="print-button">Print</button>
  </mat-dialog-actions>
</ng-template>
